import { parseMomentUtc, US_DATE_FORMAT } from 'utils/dates';
import type { EvaluationRowDetailProps } from './types';
import style from './evaluation-row-detail.module.scss';

/**
 * Formats a date string to US date format (MM/DD/YYYY).
 * @param {string | null} date - ISO date string or null
 * @return {string} Formatted date or em dash
 */
const formatDate = (date: string | null): string => {
  return date ? parseMomentUtc(date).format(US_DATE_FORMAT) : '—';
};

/**
 * Rendered inside expanded DataTable rows. Shows additional evaluation metadata
 * in a two-column layout matching the mock-ui design.
 * @param {EvaluationRowDetailProps} props - The row data
 * @return {JSX.Element} The expanded row detail
 */
export const EvaluationRowDetail = ({ row }: EvaluationRowDetailProps) => (
  <div className={style.rowDetail}>
    <div className={style.detailColumn}>
      <p className={style.detailRow}>
        <span className={style.detailLabel}>Eval Created By: </span>
        <span className={style.detailValue}>{row.createdBy ?? '—'}</span>
      </p>
      <p className={style.detailRow}>
        <span className={style.detailLabel}>Eval Created At: </span>
        <span className={style.detailValue}>{formatDate(row.createdAt)}</span>
      </p>
    </div>
    <div className={style.detailColumn}>
      <p className={style.detailRow}>
        <span className={style.detailLabel}>Includes Children: </span>
        <span className={style.detailValue}>
          {row.includeChildren !== null && row.includeChildren !== undefined
            ? row.includeChildren
              ? 'Yes'
              : 'No'
            : '—'}
        </span>
      </p>
      <p className={style.detailRow}>
        <span className={style.detailLabel}>Acquire Entity: </span>
        <span className={style.detailValue}>{row.acquirerName ?? '—'}</span>
      </p>
      <p className={style.detailRow}>
        <span className={style.detailLabel}>Close Date: </span>
        <span className={style.detailValue}>{formatDate(row.closeDate)}</span>
      </p>
      <p className={style.detailRow}>
        <span className={style.detailLabel}>Created At: </span>
        <span className={style.detailValue}>
          {formatDate(row.package?.createdAt ?? null)}
        </span>
      </p>
    </div>
  </div>
);
